class Facets extends HTMLElement {
  constructor() {
    super();

    this.form = document.querySelector('.js-facets-form') || null;
    this.productGrid = document.querySelector('.js-product-grid-content') || null;

    this._boundStatic = false;
    this._formInputBound = false;

    this._abortController = null;
    this._fetchTimer = null;
    this._lastFetchAt = 0;
    this._minFetchGap = 350;

    this.activeCountEls = [];
    this.clearBtns = [];

    if (this.form) {
      this.bindFormEvents();
      this.refreshStickyUI();
    }
  }

  cacheStickyUI() {
    this.activeCountEls = Array.from(document.querySelectorAll('.js-active-filters-count'));
    this.clearBtns = Array.from(document.querySelectorAll('.js-sticky-clear-filter'));

    this.clearBtns.forEach(btn => {
      if (btn.dataset.boundClear === '1') return;
      btn.dataset.boundClear = '1';
      btn.addEventListener('click', (event) => this.handleClearFacets(event));
    });
  }

  getActiveFiltersCount() {
    if (!this.form) return 0;

    let count = 0;

    const checked = this.form.querySelectorAll('input[type="checkbox"]:checked');
    count += checked.length;

    const qEl = this.form.querySelector('input[name="q"]');
    if (qEl && String(qEl.value || '').trim().length) count += 1;

    const minRange = this.form.querySelector(".js-min-price-range");
    const maxRange = this.form.querySelector(".js-max-price-range");
    const minInput = this.form.querySelector(".js-price-min");
    const maxInput = this.form.querySelector(".js-price-max");

    const minDefault = minRange ? parseInt(minRange.min, 10) : NaN;
    const maxDefault = maxRange ? parseInt(maxRange.max, 10) : NaN;

    const minVal = minInput ? parseInt(minInput.value, 10) : NaN;
    const maxVal = maxInput ? parseInt(maxInput.value, 10) : NaN;

    const minChanged = Number.isFinite(minDefault) && Number.isFinite(minVal) && minVal > minDefault;
    const maxChanged = Number.isFinite(maxDefault) && Number.isFinite(maxVal) && maxVal < maxDefault;

    if (minChanged || maxChanged) count += 1;

    return count;
  }

  refreshStickyUI() {
    this.cacheStickyUI();

    const count = this.getActiveFiltersCount();

    this.activeCountEls.forEach(el => {
      el.textContent = String(count);
      if (count > 0) el.classList.remove('d-none');
      else el.classList.add('d-none');
    });

    this.clearBtns.forEach(btn => {
      if (count > 0) btn.classList.remove('d-none');
      else btn.classList.add('d-none');
    });
  }

  bindFormEvents() {
    if (!this.form) return;

    if (!this._formInputBound) {
      this._formInputBound = true;

      this.form.addEventListener(
        'input',
        this.debounce((event) => {
          const t = event.target;

          if (t && (t.classList?.contains('js-min-price-range') || t.classList?.contains('js-max-price-range'))) {
            return;
          }
          if (t && (t.classList?.contains('js-price-min') || t.classList?.contains('js-price-max'))) {
            return;
          }

          this.handleFormChange();
        }, 300)
      );
    }

    this.minRange = document.querySelector(".js-min-price-range");
    this.maxRange = document.querySelector(".js-max-price-range");
    this.track    = document.querySelector(".js-slider-track");
    this.minInput = document.querySelector(".js-price-min");
    this.maxInput = document.querySelector(".js-price-max");

    if (this.track && this.minRange && this.maxRange) {
      this.minRange.addEventListener("input", () => {
        this.updateSliderTrack();
        this.refreshStickyUI();
      });
      this.maxRange.addEventListener("input", () => {
        this.updateSliderTrack();
        this.refreshStickyUI();
      });

      this.minRange.addEventListener("change", () => this.handleFormChange());
      this.maxRange.addEventListener("change", () => this.handleFormChange());

      this.updateSliderTrack();
    }

    if (this.minInput && this.maxInput) {
      this.minInput.addEventListener("input", () => {
        this.updateSliderFromInput(false);
        this.refreshStickyUI();
      });
      this.maxInput.addEventListener("input", () => {
        this.updateSliderFromInput(false);
        this.refreshStickyUI();
      });

      this.minInput.addEventListener("change", () => {
        this.updateSliderFromInput(true);
        this.handleFormChange();
      });
      this.maxInput.addEventListener("change", () => {
        this.updateSliderFromInput(true);
        this.handleFormChange();
      });

      this.minInput.addEventListener("keydown", (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.updateSliderFromInput(true);
          this.handleFormChange();
        }
      });
      this.maxInput.addEventListener("keydown", (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.updateSliderFromInput(true);
          this.handleFormChange();
        }
      });
    }

    document.querySelectorAll('.js-clear-filter').forEach(element => {
      if (element.dataset.boundClear === '1') return;
      element.dataset.boundClear = '1';
      element.addEventListener('click', (event) => this.handleClearFacets(event));
    });

    document.querySelectorAll('.js-toggle-filter').forEach(element => {
      if (element.dataset.boundToggle === '1') return;
      element.dataset.boundToggle = '1';
      element.addEventListener('click', (event) => this.handleToggleFilter(event));
    });

    this.refreshStickyUI();
  }

  buildSearchParams() {
    const formData = this.form ? new FormData(this.form) : new FormData();
    const searchParams = new URLSearchParams(formData);

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) searchParams.set('view', currentView);

    return searchParams;
  }

  handleFormChange() {
    if (!this.form) return;

    const searchParams = this.buildSearchParams();

    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.queueRender(searchParams.toString());

    this.toggleLoadingClass('add');

    this.refreshStickyUI();
  }

  handleToggleFilter(event) {
    event.preventDefault();

    document.querySelectorAll('.js-facets-container').forEach(element => {
      if (element.classList.contains("active")) {
        element.classList.add("deactivate");
        setTimeout(() => {
          element.classList.remove("active", "display");
          if (window.lenis) {
            window.lenis.start();
          } else {
            document.body.style.overflow = "visible";
          }
        }, 300);
      } else {
        element.classList.add("display");
        element.classList.remove("deactivate");
        setTimeout(() => {
          element.classList.add("active");
        }, 10);
        if (window.lenis) {
          window.lenis.stop();
        } else {
          document.body.style.overflow = "hidden";
        }
      }
    });
  }

  toggleLoadingClass(type) {
    if (type === 'add') this.classList.add('loading');
    else this.classList.remove('loading');
  }

  queueRender(searchParamsString) {
    clearTimeout(this._fetchTimer);

    const now = Date.now();
    const elapsed = now - this._lastFetchAt;
    const wait = Math.max(0, this._minFetchGap - elapsed);

    this._fetchTimer = setTimeout(() => {
      this._lastFetchAt = Date.now();
      this.renderPage(searchParamsString);
    }, wait);
  }

  abortFetch() {
    if (this._abortController) {
      try { this._abortController.abort(); } catch(e) {}
    }
    this._abortController = new AbortController();
    return this._abortController;
  }

  async renderPage(searchParams) {
    const currentView = new URL(window.location.href).searchParams.get('view');
    const viewParam = currentView ? `&view=${currentView}` : '';
    const url = `${window.location.pathname}?${searchParams}${viewParam}`;

    const controller = this.abortFetch();

    try {
      const html = await this.fetchWithRetry(url, { signal: controller.signal }, 2);

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const productGridContent = doc.querySelector('.js-product-grid-content');
      const currentGrid = document.querySelector('.js-product-grid-content');
      if (productGridContent && currentGrid) {
        currentGrid.innerHTML = productGridContent.innerHTML;

        const offset = 120;
        const elementPosition = currentGrid.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }

      const productsCounter = doc.querySelector('.js-products-counter');
      const productsCounterTarget = document.querySelector('.js-products-counter');
      if (productsCounter && productsCounterTarget) {
        productsCounterTarget.innerHTML = productsCounter.innerHTML;
      }

      const newForm = doc.querySelector('.js-facets-form');
      const currentForm = document.querySelector('.js-facets-form');
      if (newForm && currentForm) {
        const container = document.querySelector('.js-facets-container');
        const wasOpen = container?.classList.contains('active');

        currentForm.innerHTML = newForm.innerHTML;

        this.form = document.querySelector('.js-facets-form');
        this._formInputBound = false;
        this.bindFormEvents();

        this.refreshStickyUI();
      }

      if (typeof initializeObservers === 'function') initializeObservers();
      if (typeof initCollectionBanners === "function") {
        initCollectionBanners();
      }
      if (typeof window.initHeroProducts === "function") {
        window.initHeroProducts();
      }

      window.CollectionInfiniteScroll?.refresh?.();

      this.toggleLoadingClass('remove');
    } catch (error) {
      if (error?.name === 'AbortError') return;

      console.error('Error fetching filtered results:', error);
      this.toggleLoadingClass('remove');
    }
  }

  async fetchWithRetry(url, options = {}, retries = 2) {
    let attempt = 0;

    while (true) {
      attempt++;

      const res = await fetch(url, {
        ...options,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (res.ok) return await res.text();

      if (res.status === 429 && attempt <= retries) {
        const retryAfter = res.headers.get('Retry-After');
        const waitMs = retryAfter
          ? (parseFloat(retryAfter) * 1000)
          : (400 * attempt + Math.floor(Math.random() * 300));

        await new Promise(r => setTimeout(r, waitMs));
        continue;
      }

      throw new Error(`HTTP error! Status: ${res.status}`);
    }
  }

  updateSliderTrack() {
    if (!this.minRange || !this.maxRange || !this.track || !this.minInput || !this.maxInput) return;

    let minVal = parseInt(this.minRange.value, 10);
    let maxVal = parseInt(this.maxRange.value, 10);

    const minPercent = ((minVal - this.minRange.min) / (this.minRange.max - this.minRange.min)) * 100;
    const maxPercent = ((maxVal - this.maxRange.min) / (this.maxRange.max - this.maxRange.min)) * 100;

    this.track.style.left = minPercent + "%";
    this.track.style.right = (100 - maxPercent) + "%";

    this.minInput.value = minVal;
    this.maxInput.value = maxVal;
  }

  updateSliderFromInput(commit = false) {
    if (!this.minRange || !this.maxRange || !this.minInput || !this.maxInput) return;

    let minVal = parseInt(this.minInput.value, 10);
    let maxVal = parseInt(this.maxInput.value, 10);

    if (Number.isNaN(minVal)) minVal = parseInt(this.minRange.min, 10) || 0;
    if (Number.isNaN(maxVal)) maxVal = parseInt(this.maxRange.max, 10) || 0;

    if (commit) {
      if (minVal < parseInt(this.minRange.min, 10)) minVal = parseInt(this.minRange.min, 10);
      if (maxVal > parseInt(this.maxRange.max, 10)) maxVal = parseInt(this.maxRange.max, 10);
      if (minVal > maxVal) minVal = maxVal;
    }

    this.minRange.value = minVal;
    this.maxRange.value = maxVal;

    this.updateSliderTrack();
  }

  handleClearFacets(event) {
    event.preventDefault();
    if (!this.form) return;

    document.querySelectorAll('.js-facets-form input[type="checkbox"]').forEach(cb => cb.checked = false);

    const qEl = this.form.querySelector('input[name="q"]');
    if (qEl) qEl.value = '';

    const minRange = this.form.querySelector(".js-min-price-range");
    const maxRange = this.form.querySelector(".js-max-price-range");
    const minInput = this.form.querySelector(".js-price-min");
    const maxInput = this.form.querySelector(".js-price-max");
    if (minRange && maxRange && minInput && maxInput) {
      minRange.value = minRange.min;
      maxRange.value = maxRange.max;
      minInput.value = minRange.min;
      maxInput.value = maxRange.max;
      this.updateSliderTrack();
    }

    const searchParams = this.buildSearchParams();
    searchParams.delete('q');

    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.queueRender(searchParams.toString());

    this.toggleLoadingClass('add');

    this.refreshStickyUI();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('collection-facets', Facets);